const footerLinks = [
  {
    heading: 'Navigation',
    links: [
      { label: 'Home', href: '#home' },
      { label: 'About', href: '#about' },
      { label: 'Products', href: '#products' },
      { label: 'Features', href: '#features' },
      { label: 'Contact', href: '#contact' },
    ],
  },
  {
    heading: 'Products',
    links: [
      { label: 'KROKO VPN', href: '#products' },
      { label: 'KROKO Cleaner', href: '#products' },
    ],
  },
];

const contactDetails = [
  { icon: 'ri-map-pin-2-line', label: 'Address', value: 'Donja Mahala 5' },
  { icon: 'ri-building-line', label: 'City / Zip', value: 'Visoko, 71300' },
  { icon: 'ri-earth-line', label: 'Country', value: 'Bosnia and Herzegovina' },
  { icon: 'ri-mail-send-line', label: 'Email', value: 'contact@krokodoo.com' },
  { icon: 'ri-phone-fill', label: 'Phone', value: '+1 8382700220' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1C3829] text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/39e3c158-354b-498e-9f1f-29c61d5b7be6.png"
                  alt="KROKO d.o.o. logo"
                  className="w-9 h-9 object-contain"
                />
              </div>
              <span
                className="font-bold text-lg text-white"
                style={{ fontFamily: 'Syne, sans-serif' }}
              >
                KROKO d.o.o.
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Expert iOS app development from Visoko, Bosnia and Herzegovina.
              Building secure, high-performance mobile applications for users worldwide.
            </p>
          </div>

          {/* Nav columns */}
          {footerLinks.map((col) => (
            <div key={col.heading}>
              <h5
                className="text-white text-xs font-bold uppercase tracking-[0.18em] mb-5"
                style={{ fontFamily: 'Syne, sans-serif' }}
              >
                {col.heading}
              </h5>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                      className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact */}
          <div>
            <h5
              className="text-white text-xs font-bold uppercase tracking-[0.18em] mb-5"
              style={{ fontFamily: 'Syne, sans-serif' }}
            >
              Contact
            </h5>
            <ul className="flex flex-col gap-3.5">
              {contactDetails.map((item) => (
                <li key={item.label} className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                    <i className={`${item.icon} text-[#C74B1C] text-xs`} />
                  </div>
                  <div>
                    <span className="text-white/40 text-xs uppercase tracking-wider font-medium">
                      {item.label}:{' '}
                    </span>
                    <span className="text-white/70 text-sm">{item.value}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} KROKO d.o.o. All rights reserved.
          </p>
          <p className="text-white/30 text-xs">
            Donja Mahala 5, Visoko 71300, Bosnia and Herzegovina
          </p>
        </div>
      </div>
    </footer>
  );
}
